import { useCallback } from 'react';
import { ROUTE_KEYS } from 'legacyfrontend/constants';
import { targetFromUrl } from 'legacyfrontend/utils/url';

export const useBannerNavigation = () => {
  const getNavigationUrl = useCallback((data) => {
    const { urlPackage, url, esConsulta, detalle, id } = data;
    
    if (urlPackage) {
      if (urlPackage.startsWith('http')) {
        return urlPackage;
      }
      
      return `${urlPackage}`;
    }

    if (url) {
      return url;
    }

    if (esConsulta && id) {
      return `${ROUTE_KEYS.CONSULTA}/${id}`;
    }

    if (detalle && id) {
      return `${ROUTE_KEYS.CONSULTA}/${id}`;
    }

    return '#';
  }, []);

  const getNavigationTarget = useCallback((data) => {
    const { urlPackage, url, esConsulta } = data;
    
    if (urlPackage && urlPackage.startsWith('http')) {
      return '_blank';
    }

    if (urlPackage) {
      return '_blank';
    }

    if (url) {
      return targetFromUrl(url);
    }

    if (esConsulta) {
      return '_self';
    }

    return '_self';
  }, []);

  const getNavigationProps = useCallback((data) => {
    const href = getNavigationUrl(data);
    const target = getNavigationTarget(data);
    
    return {
      href,
      target,
    };
  }, [getNavigationUrl, getNavigationTarget]);

  return {
    getNavigationUrl,
    getNavigationTarget,
    getNavigationProps,
  };
};

export default useBannerNavigation;